window.addEventListener('DOMContentLoaded', function () {
  jQuery(function ($) {
    $('.camp-finder__search-cta').on('click', function () {
      let searchParams = new URLSearchParams();

      let inputs = $(this)
        .closest('.camp-finder__options-wrapper')
        .find('input');

      inputs.get().forEach((input) => {
        searchParams.append(input.name, input.value);
      });

      const sport = searchParams.get('sport'),
        city = searchParams.get('city'),
        campOrProgram = $(this)
          .closest('.camp-finder__options-wrapper')
          .find(
            `.camp-finder__dropdown-item [data-search-term="${searchParams.get('sport')}"]`,
          )
          .attr('data-type');

      if (!sport || !city || !campOrProgram) {
        return;
      }

      window.location.href = `/pages/${city}-${sport}-${campOrProgram}`;
    });

    let carousel = new Swiper(
      '.camp-finder__unique-selling-points-wrapper.swiper:not(.swiper-initialized)',
      {
        slidesPerView: 1,
        allowTouchMove: true,
        spaceBetween: 34,
        loop: false,
        autoplay: {
          delay: 5000,
        },
        on: {
          resize: function (swiper) {
            swiper.slideTo(0);
          },
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            allowTouchMove: true,
            autoplay: {
              delay: 5000,
            },
          },
          1280: {
            slidesPerView: 'auto',
            allowTouchMove: false,
            autoplay: false,
          },
        },
      },
    );
  });
});
